
import { useEffect } from 'react';
import { InsightCard, transformDatabaseCard } from '@/types/insight';
import { useCollectionRealtime } from './realtime/useCollectionRealtime';

/**
 * Hook to set up real-time subscription for insight card updates using Universal Real-time Manager
 * @param setCards Function to update insight cards state
 */
export const useInsightCardsRealtime = (
  setCards: React.Dispatch<React.SetStateAction<InsightCard[]>>
) => {
  const { isConnected, connectionStatus } = useCollectionRealtime(
    'cards',
    {}, // No specific filters, monitor all cards
    {
      onItemAdded: (payload) => {
        console.log('Adding new insight card to state:', payload);
        const transformedCard = transformDatabaseCard(payload);
        setCards(currentCards => [transformedCard, ...currentCards]);
      },
      
      onItemUpdated: (payload) => {
        console.log('Updating existing insight card:', payload);
        setCards(currentCards => 
          currentCards.map(card => 
            card.id === payload.id 
              ? transformDatabaseCard(payload) 
              : card
          )
        );
      },
      
      onItemRemoved: (itemId) => {
        console.log('Removing deleted insight card:', itemId);
        setCards(currentCards => 
          currentCards.filter(card => card.id !== itemId)
        );
      },
      
      onError: (error) => {
        console.error('Insight cards real-time error:', error);
      }
    },
    true // Always enabled
  );

  return {
    isConnected,
    connectionStatus
  };
};
